import gql from "graphql-tag";
import { VALUE_LIST_FRAGMENT } from "./valuelist-gql";

const ORG_DETAILS_FRAGMENT = gql`
    ${VALUE_LIST_FRAGMENT}
    fragment orgDetailsFragment on OrgDetails {
        orgAcronym
        category {
            id
            categoryName
            type
        }
        orgType {
            ...valueListFragment
        }
        orgPrefix {
            ...valueListFragment
        }
        description
        restricted
        shareLinkId
        frenchName
	    frenchNameTranslated
	    frenchDescription
	    frenchDescriptionTranslated
    }
`;

export const GET_CATEGORIES = gql`
    query Categories {
        categories {
            id
            categoryName
            type
        }
    }
`

export const GET_GLOBAL_CATEGORIES = gql`
    query GlobalCategories {
        globalCategories {
            id
            categoryName
            type
        }
    }
`

export const GET_ROOT_ORGS = gql`
    query RootOrgs($categoryId:ID!) {
        rootOrgs(categoryId:$categoryId) {
            id
            orgName
            hasChild
            createDate
            orgAcronym
            parentOrgId
            clonedFromOrgId
            sharedToOrgIds
        }
    }
`;

export const GET_GLOBAL_ROOT_ORGS = gql`
    query GlobalRootOrgs($categoryId:ID!) {
        globalRootOrgs(categoryId:$categoryId) {
            id
            orgName
            hasChild
            createDate
            orgAcronym
        }
    }
`;

export const GET_ALL_ROOT_ORGS = gql`
    query AllRootOrgs {
        allRootOrgs {
            id
            orgName
        }
    }
`;

export const GET_CHILD_ORGS = gql`
    query ChildOrgs($id: ID!) {
        childOrgs(orgId: $id) {
            id
            orgName
            hasChild
            parentOrgId
            createDate
            clonedFromOrgId
            sharedToOrgIds
        }
    }
`;

export const GET_ORG_DETAILS = gql`
    ${ORG_DETAILS_FRAGMENT}
    query Org($id: ID!) {
        org(orgId: $id) {
            id
            orgName
            parentOrg {
                id
                orgName
                startDate
            }
            parentOrgId
            details {
                ...orgDetailsFragment
            }
            clonedFromOrgId
            sharedToOrgIds    
        }
    }
`;

export const GET_ORG_PATH = gql`
    query OrgPath($id: ID!) {
        orgPath(orgId: $id) 
    }
`;

export const GET_ORG_PATH_ID = gql`
    query OrgPathId($id: ID!) {
        orgPathId(orgId: $id) 
    }
`;
export const GET_ORG_RELATIONSHIPS = gql`
    ${VALUE_LIST_FRAGMENT}
    query Org($orgId: ID!) {
        org(orgId:$orgId){
            id
            relationships {
                relationshipId
                destOrgId
                destOrgName
                destParentOrgId
                destCloned
                relationshipType {
                    ...valueListFragment                   
                }
                createTimestamp
                restricted
                positive
            }
        }
    }
`;

export const GET_ORG_CATEGORY = gql`
    query Org($orgId:ID!){
        org(orgId:$orgId){
            id
            details {
                category {
                    id
                    categoryName
                    type
                }
            }
        }
    }
`;

export const CREATE_ORG = gql`
    ${ORG_DETAILS_FRAGMENT}
    mutation CreateOrg($id: ID!, $input: OrgInput!,$isParentCategory: Boolean!) {
        createOrg(parentOrgId: $id, input: $input,isParentCategory:$isParentCategory) {
            id
            details {
                ...orgDetailsFragment
            }
        }
    }
`;

export const UPDATE_ORG = gql`
    ${ORG_DETAILS_FRAGMENT}
    mutation UpdateOrg($id: ID!, $input: OrgInput!) {
        updateOrg(orgId: $id, input: $input) {
            id
            orgName
            details {
                ...orgDetailsFragment
            }
        }
    }
`;

export const DELETE_ORG = gql`
    mutation DeleteOrg($id: ID!) {
        deleteOrg(orgId: $id) 
    }
`;

export const EXPIRE_ORG = gql`
    mutation ExpireOrg($orgId: ID!) {
        expireOrg(orgId: $orgId) {
            success
            code
            message
        }
    }
`;

export const MOVE_ORG = gql`
    mutation MoveOrgs($orgId:ID!,$action:Action!,$input:CreateRelationshipInput!){
        moveOrgs(orgId:$orgId,action:$action,input:$input){
            action,
            success,
            code,
            message
        }
    } 
`;

export const IS_CHILD = gql`
    query IsChild($parentIds:[ID]!,$childId:ID!){
        isChild(parentIds:$parentIds,childId:$childId)
    }
`;

export const HAS_CLONED_DESCENDANT = gql`
    query HasClonedDescendant($orgId:ID!){
        hasClonedDescendant(orgId:$orgId)
    }
`;



export const ADD_OTHER_ORG = gql`
    mutation AddOtherOrg($orgId:ID!,$action:Action!,$input:CreateRelationshipInput!){
        addOtherOrg(orgId:$orgId,action:$action,input:$input){
            action,
            success,
            code,
            message
        }
    } 
`;

export const REMOVE_OTHER_ORGS = gql`
    mutation RemoveOtherOrgs($orgId:ID!,$action:Action!,$input:CreateRelationshipInput!){
        removeOtherOrgs(orgId:$orgId,action:$action,input:$input){
            action,
            success,
            code,
            message
        }
    }
`;

export const IS_SCOPE = gql`
    query IsScope($orgId:ID!,$isLowerLevel:Boolean!){
        isScope(orgId:$orgId,isLowerLevel:$isLowerLevel)         
    }
`;

export const IS_REMOVABLE = gql`
    query IsRemovable($orgId:ID!){
        isRemovable(orgId:$orgId){
            success
            code
            message
        }         
    }
`;

export const SEARCH_ORG = gql`
query SearchOrg($input: SearchOrgInput!) {
    searchOrg(input:$input){
        message
        orgs{
            id
            orgName
            restricted
            desc
            addressUsages{
                id
                addressTxt
                addressTxt2
                primary
                addressExpired
            }
            contactPhones{
                id
                countryCode
                areaCode
                localNumber
                extension
                description
                phoneType{
                    id
                    code
                    label
                    label2
                }
                assignType{
                    id
                    code
                    label
                    label2
                }
            }
        }
    }
}
`;

